export const v3Base = {
  bg: "var(--background)",
  surf: "var(--card)",
  surf2: "var(--secondary)",
  line: "var(--border)",
  line2: "var(--input)",
  fg: "var(--foreground)",
  fg2: "var(--secondary-foreground)",
  dim: "var(--muted-foreground)",
  dim2: "var(--dim2)",
  dim3: "var(--dim3)",
  sans: '"Geist", -apple-system, "SF Pro Text", system-ui, sans-serif',
  mono: '"Geist Mono", ui-monospace, "JetBrains Mono", monospace',
};

export const ACCENTS = {
  cyan:    { label: "Signal Cyan",  c: "oklch(0.86 0.14 198)", c2: "oklch(0.86 0.14 198 / 0.18)", c3: "oklch(0.86 0.14 198 / 0.06)" },
  amber:   { label: "Ember Amber",  c: "oklch(0.82 0.15 65)",  c2: "oklch(0.82 0.15 65 / 0.20)",  c3: "oklch(0.82 0.15 65 / 0.07)" },
  lime:    { label: "Spring Lime",  c: "oklch(0.90 0.19 130)", c2: "oklch(0.90 0.19 130 / 0.18)", c3: "oklch(0.90 0.19 130 / 0.06)" },
  magenta: { label: "Hot Magenta",  c: "oklch(0.74 0.22 350)", c2: "oklch(0.74 0.22 350 / 0.22)", c3: "oklch(0.74 0.22 350 / 0.08)" },
};

// Default export v3 theme mapped to CSS variables
export const v3 = {
  ...v3Base,
  accent: "var(--primary)",
  accentDim: "var(--ac-dim)",
  accentBg: "var(--accent)",
  intense: true
};

export function inkAccent() {
  return v3.intense ? v3.accent : v3.fg;
}
export const inkAccent2 = () => (v3.intense ? v3.accentDim : v3.line2);
